import type { SlateBlock, SlateLeaf } from '@atlas/renderer';
import { Editor, Location, Span, type NodeMatch } from 'slate';

export default function matchNodes<T extends SlateBlock | SlateLeaf>(editor: Editor, options?: NodeMatchOptions<T>) {
    return Array.from(Editor.nodes(editor, options));
}

// #region Types

export type NodeMatchOptions<T extends SlateBlock | SlateLeaf> = {
    at?: Location | Span;
    match?: NodeMatch<T>;
    mode?: 'all' | 'highest' | 'lowest';
    universal?: boolean;
    reverse?: boolean;
    voids?: boolean;
};

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('matchNodes', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
